export default function Logo({compact = false}) {
  return (
    <div className={compact ? "brand compact" : "brand"} data-testid="brand-wordmark">
      <div className="brand-text">
        <strong>Indian</strong>
        <em>Ocean</em>
      </div>
    </div>
  );
}
